import React from 'react'
import useStyles from './Timeline.style'
import moment from 'moment'

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import FlagIcon from '@material-ui/icons/Flag';

const TimelineView = props => {
    const classes = useStyles()
    const { item, infoFields, workflow, authorized, loading } = props

    const fileFields = []
    if (workflow) {
        for (let i in workflow.steps) {
            for (let j in workflow.steps[i].fields) {
                if (workflow.steps[i].fields[j].type === 'file') {
                    fileFields.push(workflow.steps[i].fields[j].id)
                }
            }
        }
    }

    const getIcon = step => {
        if (step.created && step.hash)
            return (
                <React.Fragment>
                    <TimelineDot color='primary'>
                        <DoneAllIcon />
                    </TimelineDot>
                    <TimelineConnector />
                </React.Fragment>
            )
        if (step.created)
            return (
                <React.Fragment>
                    <TimelineDot color='primary'>
                        <DoneIcon />
                    </TimelineDot>
                    <TimelineConnector />
                </React.Fragment>
            )
        if (step.conclusion)
            return (
                <TimelineDot color='primary' variant='outlined'>
                    <FlagIcon />
                </TimelineDot>
            )
        return (
            <React.Fragment>
                <TimelineDot color='grey'>
                    <HourglassFullIcon />
                </TimelineDot>
                <TimelineConnector />
            </React.Fragment>
        )
    }

    if (loading) return (<p>...</p>)
    if (!authorized) return(<p>You don't have access to this item.</p>)

    return (
        <Paper className={classes.contentWrapper}>
            <div className={classes.header}>
                <Typography variant='h2'>Item Details</Typography>
                <ul>
                    {infoFields.map(info => (
                        <li>
                            <strong>{info.label}</strong>
                        : {info.value}
                        </li>
                    ))}
                    <li><strong>Created</strong>: {moment(item?.created).format('DD/MM/YYYY HH:mm')}</li>
                    <li><strong>Last Changed</strong>: {moment(item?.lastChanged).format('DD/MM/YYYY HH:mm')}</li>
                </ul>
            </div>
            <Timeline align="alternate" className={classes.timeline}>
                {
                    workflow?.steps.map((step, idx) => {
                        // console.log(item)
                        if (step.id in item.steps) return { ...item.steps[step.id], id: step.id }
                        return {
                            hash: false,
                            created: false,
                            links: false,
                            id: step.id,
                            conclusion: idx === workflow.steps.length - 1
                        }
                    }).map(step => (
                        <TimelineItem>
                            <TimelineOppositeContent>
                                <Typography variant="body2" color="textSecondary">
                                    {step.created ? moment(step.created).format('DD/MM/YYYY HH:mm') : ''}
                                </Typography>
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                {getIcon(step)}
                            </TimelineSeparator>
                            <TimelineContent>
                                <Paper elevation={1} className={classes.paper}>
                                    <Typography variant="h6" component="h1">
                                        {workflow ? workflow.steps.find(wStep => wStep.id === step.id).name : ''}
                                    </Typography>
                                    <Typography>{
                                        step.fields ?
                                            step.fields.filter(field => fileFields.includes(field.id))
                                                .map(field =>
                                                    <a href={field.value.url} rel="noopener noreferrer" className={classes.fileLink} target='_blank'><CloudDownloadIcon /></a>
                                                )
                                            : ''
                                        }
                                    </Typography>
                                    <Typography>{step?.links?.etherscan ? <a href={step.links.etherscan} rel="noopener noreferrer" target='_blank'>Registro protegido</a> : ''}</Typography>
                                </Paper>
                            </TimelineContent>
                        </TimelineItem>
                    ))
                }
            </Timeline>
        </Paper>
    )
}

export default TimelineView
